import type { ProblemDetails } from "@restlab/shared";

let csrfToken = "";

const configuredApiBase = (import.meta.env.VITE_API_BASE_URL as
  | string
  | undefined)?.replace(/\/$/, "");

export function apiUrl(path: string) {
  if (!path.startsWith("/"))
    throw new Error("Las rutas de API deben comenzar por '/'.");
  return configuredApiBase ? `${configuredApiBase}${path}` : path;
}

export function setCsrfToken(token: string) {
  csrfToken = token;
}

export class ApiError extends Error {
  constructor(public readonly problem: ProblemDetails) {
    super(problem.detail);
  }
}

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  const method = init.method?.toUpperCase() ?? "GET";
  const headers = new Headers(init.headers);
  if (
    init.body &&
    !(init.body instanceof FormData) &&
    !headers.has("Content-Type")
  )
    headers.set("Content-Type", "application/json");
  if (!["GET", "HEAD", "OPTIONS"].includes(method) && csrfToken)
    headers.set("X-CSRF-Token", csrfToken);
  const response = await fetch(apiUrl(path), {
    ...init,
    headers,
    credentials: "include",
    ...(["GET", "HEAD"].includes(method) ? { cache: "no-store" as const } : {}),
  });
  if (!response.ok) {
    const problem = (await response.json().catch(() => ({
      title: "No se pudo completar",
      detail: "Comprueba la conexión y vuelve a intentarlo.",
      status: response.status,
      type: "about:blank",
      code: "NETWORK_ERROR",
      correlationId: "client",
    }))) as ProblemDetails;
    throw new ApiError(problem);
  }
  return response.json() as Promise<T>;
}

export function idempotencyKey(prefix: string) {
  return `${prefix}-${crypto.randomUUID()}`;
}
